import { devtools, subscribeWithSelector } from "zustand/middleware";
import { immer } from "zustand/middleware/immer";
import { createStore } from "zustand/vanilla";
import type { PrebidStore } from "@/ts/types";

export const initialState = {
	auctions: {} as Record<number, { bidders: string[] }>,
	bidderData: {} as Partial<import("@/ts/prebid/types").PageMiscData>,
};

export const prebidStore = createStore<PrebidStore>()(
	devtools(
		subscribeWithSelector(
			immer((set, get) => ({
				...initialState,
				actions: {
					setBidderData: (data) =>
						set((state) => {
							state.bidderData = { ...state.bidderData, ...data };
						}),
					setBidders: (auctionId, bidders) =>
						set((state) => {
							state.auctions[auctionId] = { bidders };
						}),
				},
				selectors: {
					getBidderData: () => get().bidderData,
					getBidders: (auctionId) => get().auctions[auctionId]?.bidders ?? [],
				},
			})),
		),
		{
			name: "Hydra-PrebidStore",
		},
	),
);
